import request from '@/utils/http';
// 查询菜单对应文档
export const getResourceFile = (resourceCode) => {
    return request({
        url: `/api-bms/api/helpFunctionController/helpFunction/${resourceCode}`,
        method: 'get'
    });
};